import imageCompression from 'browser-image-compression';

const defaultOptions = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
};

export const imageHelper = {
    async compressFile(file, options = {}) {
        if (!file.type.startsWith('image/')) return file;
        const compressed = await imageCompression(file, { ...defaultOptions, ...options });
        return new File([compressed], file.name, { type: compressed.type });
    },
    compressFiles(files, options = {}) {
        return Promise.all((files || []).map(f => this.compressFile(f, options)));
    },
};
